import { SEOHead } from "@/components/SEOHead";
import { HeaderNavigation } from "@/components/HeaderNavigation";
import { FooterSEO } from "@/components/FooterSEO";
import { Breadcrumbs } from "@/components/Breadcrumbs";
import { PropertyCard } from "@/components/PropertyCard";
import { useListings } from "@/hooks/use-listings";
import { Store, Building2, Briefcase, TrendingUp } from "lucide-react";
import { Card } from "@/components/ui/card";

export default function CommercialRealEstatePage() {
  const { listings } = useListings();
  const commercialListings = listings.filter((p) => ["isyeri", "dukkan", "ofis"].includes(p.category));

  return (
    <div className="min-h-screen bg-background flex flex-col justify-between">
      <SEOHead
        title="Adana Ticari Gayrimenkul & Satılık Dükkan | Corner Gayrimenkul"
        description="Adana Seyhan ve Çukurova caddelerinde satılık ve kiralık dükkan, mağaza, ofis, plaza katı ve devren ticari portföyler."
        canonicalPath="/ticari-gayrimenkul"
      />
      <HeaderNavigation />

      <main className="flex-1 py-8 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto w-full">
        <Breadcrumbs items={[{ label: "Ticari Gayrimenkul" }]} />

        {/* Hero Section */}
        <div className="relative rounded-3xl overflow-hidden bg-slate-900 text-white p-8 sm:p-12 mb-12 shadow-2xl border border-slate-800">
          <div className="max-w-3xl space-y-4">
            <span className="px-3 py-1 rounded-full bg-primary/20 text-primary border border-primary/30 text-xs font-bold uppercase tracking-wider flex items-center gap-1.5 w-fit">
              <Store className="h-3.5 w-3.5" /> Ticari & Kurumsal Portföy
            </span>
            <h1 className="text-3xl sm:text-5xl font-black tracking-tight leading-tight">
              Adana Ticari Gayrimenkul & Dükkan
            </h1>
            <p className="text-slate-300 text-lg leading-relaxed">
              Bulvar üzeri yüksek yaya ve araç trafiğine sahip dükkanlar, plaza ofisleri ve kurumsal kiracılı ticari yatırım fırsatları.
            </p>
          </div>
        </div>

        {/* Features */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
          <Card className="p-6 bg-card border border-border">
            <Store className="h-8 w-8 text-primary mb-3" />
            <h3 className="font-bold text-lg text-foreground mb-1">Bulvar Üzeri Dükkanlar</h3>
            <p className="text-sm text-muted-foreground">Aliya İzzetbegoviç ve Turgut Özal bulvarlarında yüksek tabela değeri.</p>
          </Card>

          <Card className="p-6 bg-card border border-border">
            <Briefcase className="h-8 w-8 text-primary mb-3" />
            <h3 className="font-bold text-lg text-foreground mb-1">Plaza & Ofis Katları</h3>
            <p className="text-sm text-muted-foreground">Kurumsal firmalar için prestijli iş merkezi ve plaza ofis seçenekleri.</p>
          </Card>

          <Card className="p-6 bg-card border border-border">
            <TrendingUp className="h-8 w-8 text-primary mb-3" />
            <h3 className="font-bold text-lg text-foreground mb-1">Kurumsal Kiracılı Yatırım</h3>
            <p className="text-sm text-muted-foreground">Mevcut kira sözleşmesi, kullanım amacı ve mülk özellikleriyle değerlendirme.</p>
          </Card>
        </div>

        {/* Listings Grid */}
        <section className="mb-12">
          <h2 className="text-2xl font-extrabold text-foreground mb-6">
            Aktif Ticari Gayrimenkul Portföyleri
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {commercialListings.length > 0 ? (
              commercialListings.map((prop) => (
                <PropertyCard key={prop.id} property={prop} />
              ))
            ) : (
              <p className="text-muted-foreground col-span-3">Şu anda gösterilecek ticari portföy bulunmamaktadır.</p>
            )}
          </div>
        </section>
      </main>

      <FooterSEO />
    </div>
  );
}
